import { render, staticRenderFns } from "./score-component-entry.vue?vue&type=template&id=26571b6d&scoped=true&"
import script from "./score-component-entry.vue?vue&type=script&lang=js&"
export * from "./score-component-entry.vue?vue&type=script&lang=js&"
import style0 from "./score-component-entry.vue?vue&type=style&index=0&id=26571b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26571b6d",
  null
  
)

export default component.exports